import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Delivery from "./Component/Delivery";
import Faqs from "./Component/Faqs";
import Cookies from "./Component/Cookies";
import {
  AccessibilityPolicy,
  CancellationsPolicy,
  ComplaintsPolicy,
  ContactPolicy,
  DeliveryIssuesPolicy,
  IntellectualPropertyPolicy,
  LimitedStockPolicy,
  OfferCodesPolicy,
  OrdersPaymentPolicy,
  PolicyHub,
  PrivacyChoicesPolicy,
  ProductCarePolicy,
  ProductInformationPolicy,
  TermsUsePolicy,
} from "./Component/StorePolicies";

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms-of-sale" element={<Terms />} />
          <Route path="/terms" element={<Navigate replace to="/terms-of-sale" />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
          <Route path="/payment" element={<PaySuccess />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/policies" element={<PolicyHub />} />
          <Route path="/orders-payment" element={<OrdersPaymentPolicy />} />
          <Route path="/cancellations" element={<CancellationsPolicy />} />
          <Route path="/delivery-issues" element={<DeliveryIssuesPolicy />} />
          <Route path="/limited-stock" element={<LimitedStockPolicy />} />
          <Route path="/offer-codes" element={<OfferCodesPolicy />} />
          <Route path="/product-information" element={<ProductInformationPolicy />} />
          <Route path="/accessibility" element={<AccessibilityPolicy />} />
          <Route path="/privacy-choices" element={<PrivacyChoicesPolicy />} />
          <Route path="/terms-of-use" element={<TermsUsePolicy />} />
          <Route path="/intellectual-property" element={<IntellectualPropertyPolicy />} />
          <Route path="/product-care" element={<ProductCarePolicy />} />
          <Route path="/complaints" element={<ComplaintsPolicy />} />
          <Route path="/contact-policy" element={<ContactPolicy />} />
          <Route path="/warranty" element={<Navigate replace to="/returns" />} />
          <Route path="/acceptable-use" element={<Navigate replace to="/terms-of-use" />} />
          <Route path="/security" element={<Navigate replace to="/orders-payment" />} />
          <Route path="/promotions" element={<Navigate replace to="/offer-codes" />} />
          <Route path="/legal-notice" element={<Navigate replace to="/contact-policy" />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;
